module.exports = (require("./helpers/browser/import-polyfill")(parcelRequire.resolve("dSvR6"))).then(() => parcelRequire('974eL'));